import React from "react";
import BundleContext from "./context/context";
import BundleWrapper from "./ui/BundleWrapper";

function Bundle() {
	return (
		<BundleContext>
			<BundleWrapper />
		</BundleContext>
	);
}

export default Bundle;
